import React from 'react';
import coordsIcon from '../../../assets/coords.png';


const CoordinatesLink = ({ latitude, longitude, iconSrc }) => {
  const roundedLat = Math.round(latitude * 10000) / 10000;
  const roundedLng = Math.round(longitude * 10000) / 10000;
  const mapUrl = `https://maps.google.com/?t=k&q=${latitude},${longitude}`;

  const styles = {
    container: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '5px',
    },
    icon: {
      height: '15px',
    },
    link: {
      textDecoration: 'none',
    },
  };

  return (
    <div style={styles.container}>
      <img src={coordsIcon} alt="coordinates" style={styles.icon} />
      <a href={mapUrl} target="_blank" rel="noopener noreferrer" style={styles.link}>
        {roundedLng}, {roundedLat} <br /> Ver en Google Maps
      </a>
    </div>
  );
};

export default CoordinatesLink;
